module.exports = {"220221100":"口前镇","220221101":"双河镇","220221102":"西阳镇","220221103":"北大湖镇","220221104":"一拉溪镇","220221171":"万昌镇","220221172":"永吉经济开发区（特殊乡镇）","220221200":"金家乡","220221201":"黄榆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220221.json
// module id = 621
// module chunks = 0